import { SendPaymentsTheme } from "@sendpayments/react-shared/components/common-components/SendPaymentsTheme";
import React from "react";
import { render } from "react-dom";
import getConfig from "./app.config";
import LeadsWidget from "./pages/LeadsWidget/LeadsWidget";

const load = () => {
  render(
    <SendPaymentsTheme name="SendPayments" theme="sendpayments">
      <LeadsWidget config={getConfig()}/>
    </SendPaymentsTheme>,
    document.getElementById("root")
  );
};

load();
